<template>
    <transition name="cz3__fade">
        <div
            v-if="showModal"
            class="z-50 fixed top-0 left-0 w-full h-full flex flex-col justify-center items-center bg-black bg-opacity-30"
        >
            <div class="shadow-md rounded w-11/12 max-w-sm p-9 bg-white font-gotham text-black text-center">
                <h1 class="mb-2 text-lg font-bold">
                    {{ modalHeading }}
                </h1>

                <p class="text-sm">
                    {{ modalCopy }}
                </p>

                <div v-if="showCancel || showConfirm"
                    class="mt-9 flex justify-center gap-4">
                    <base-button-flat
                        v-if="showCancel"
                        @click="emitClose"
                        variant="secondary"
                        class="w-1/2 h-10 capitalize"
                    >
                        {{ $t('CANCEL') }}
                    </base-button-flat>

                    <base-button-flat
                        v-if="showConfirm"
                        @click="emitConfirm"
                        class="w-1/2 h-10 capitalize"
                    >
                        {{ ctaCopy }}
                    </base-button-flat>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import BaseButtonFlat from './BaseButtonFlat.vue';

    export default {
        components: {
            BaseButtonFlat,
        },

        props: {
            showModal: {
                type: Boolean,
                default: false,
            },
            modalHeading: {
                type: String,
                default: '',
            },
            modalCopy: {
                type: String,
                default: '',
            },
            ctaCopy: {
                type: String,
                required: true,
            },
            showCancel: {
                type: Boolean,
                default: true,
            },
            showConfirm: {
                type: Boolean,
                default: true,
            },
        },

        methods: {
            emitClose() {
                this.$emit('modalClose');
            },

            emitConfirm() {
                this.$emit('confirmAndExit');
            },
        },
    };
</script>
